import Userfront from '@userfront/core'
import { initGraphQLTada } from 'gql.tada'
import { GraphQLClient } from 'graphql-request'

import {
  create_graphql_call,
  create_graphql_multi_call,
} from '../helpers/utilities.ts'

import type { introspection } from './server_admin_schema_graphql_env.d.ts'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    ISO8601Date: ISO8601Date
    ISO8601DateTime: ISO8601DateTime
    ID: RubyID
    CryptoAddress: CryptoAddress
    BigDecimal: string
    BigInt: string
    Timestamp: string
    Int: number
  }
  disableMasking: true
}>()

export const server_client = new GraphQLClient(
  `${import.meta.env.VITE_API_URL}/graphql/admin`,
  {
    headers: () => ({
      Authorization: Userfront.tokens.accessToken
        ? `Bearer ${Userfront.tokens.accessToken}`
        : '',
    }),
  },
)

export const graphql_call = create_graphql_call(server_client)
export const graphql_multi_call = create_graphql_multi_call(server_client)
